/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
} from './VisualReference';

/**
 * 
 * @export
 * @interface LeadDiagnosis
 */
export interface LeadDiagnosis {
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    source: LeadDiagnosisSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LeadDiagnosis
     */
    is_primary: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    short_description?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    long_description?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    onset_date?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    resolved_date?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDiagnosis
     */
    additional_information?: string;
    /**
     * 
     * @type {Array<VisualReference>}
     * @memberof LeadDiagnosis
     */
    visual_references?: Array<VisualReference>;
}


/**
 * @export
 */
export const LeadDiagnosisSourceEnum = {
    AiExtracted: 'ai_extracted',
    ReferralPlatformProvided: 'referral_platform_provided',
    UserAdded: 'user_added'
} as const;
export type LeadDiagnosisSourceEnum = typeof LeadDiagnosisSourceEnum[keyof typeof LeadDiagnosisSourceEnum];


/**
 * Check if a given object implements the LeadDiagnosis interface.
 */
export function instanceOfLeadDiagnosis(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "is_primary" in value;

    return isInstance;
}

export function LeadDiagnosisFromJSON(json: any): LeadDiagnosis {
    return LeadDiagnosisFromJSONTyped(json, false);
}

export function LeadDiagnosisFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadDiagnosis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'source': json['source'],
        'is_primary': json['is_primary'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'short_description': !exists(json, 'short_description') ? undefined : json['short_description'],
        'long_description': !exists(json, 'long_description') ? undefined : json['long_description'],
        'onset_date': !exists(json, 'onset_date') ? undefined : json['onset_date'],
        'resolved_date': !exists(json, 'resolved_date') ? undefined : json['resolved_date'],
        'additional_information': !exists(json, 'additional_information') ? undefined : json['additional_information'],
        'visual_references': !exists(json, 'visual_references') ? undefined : ((json['visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function LeadDiagnosisToJSON(value?: LeadDiagnosis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'source': value.source,
        'is_primary': value.is_primary,
        'code': value.code,
        'short_description': value.short_description,
        'long_description': value.long_description,
        'onset_date': value.onset_date,
        'resolved_date': value.resolved_date,
        'additional_information': value.additional_information,
        'visual_references': value.visual_references === undefined ? undefined : ((value.visual_references as Array<any>).map(VisualReferenceToJSON)),
    };
}

